<template>
    <section  v-if="hasPermissions(['Utilities-Project-Codes-Mass-Add Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                To add a task to many rooms at one time, select Daily, Project or Policing. Select a task and enter the frequency you want the task to be. Narrow your search by selecting a Building, Level, and Area. Select all rooms or individual rooms. Click "Add Code".
            </p>
        </div>

        <div class="row mb-0" style="margin-top:20px;">
            <div class="col-md-8 col-xs-12 col-sm-12 pt-0">
                <div class="row mb-0">
                    <div class="col-md-9 col-xs-4 pt-0">
                        <div class="row mb-0">
                            <div class="col-12">
                                <div class="row mb-0 forecaster__radiobuttons">
                                    <div v-for="(value, i) in radio_options" :key="i" :class="value.div_class">
                                        <input 
                                            :class="value.input_class"
                                            :name="'radio_input'"
                                            :type="'radio'"
                                            :id="value.ref"
                                            v-model="form_data.type"
                                            :value="value.ref"
                                        />
                                        <label :for="value.ref" :class="value.label_class" v-html="value.name"/>
                                    </div> 
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row no-gutters mb-0">
                                    <form class="w-100">
                                        <FormDynamic
                                            :form_format="form_data.type === 'project' ? form_format_project : form_format"
                                            :form_data="form_data"
                                            :array_options="array_options"
                                            :for_update="false"
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr style="margin-top:-10px;"/>

        <RoomAdvancedSearch
        :show_sq_ft="false"
        ref="advanced_search"
        :checkeable="true"
        :rest_api="'rooms_advanced_search'"
        :rest_api_pagination="'rooms_advanced_search_pagination'"
        :table_headers="table_headers"
        @passInitialData="getInitialData($event)"
        />

        <div class="row py-0 d-flex justify-content-md-end">
            <div class="col-md-12">
                <button @click="add_codes()" class="mx-md-0 modal__buttons__item w-auto float-right px-3" v-html="'Add Code'"/>
            </div>
        </div>
           
        <ValidationModal 
        :validation_table_headers="validation_table_headers"
        :validate_data="validate_data"
        :breadcrumb="breadcrumb"
        :message="'The following rooms did not pass the validations'"
        />
        <WaitingModal/>
    </section>
   <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import FormResources from './form_resources'
import ValidationModal from '@/components/ValidationModal'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import RoomAdvancedSearch   from    '@/components/BuildingComponent/Rooms/AdvancedSearch/RoomAdvancedSearch'
import Resources from './resources'
import 'vuetify/dist/vuetify.min.css'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: 'ProjectCodeMassAdd',

    components: {
        ValidationModal,
        Breadcrumb,
        WaitingModal,
        FormDynamic,
        UnauthorizedComponent,
        RoomAdvancedSearch
    },
    
    data() 
    {
        return {
            notyf,
            title_page:           'Mass Add Codes',
            title_room_tab:       'Rooms',
            rest_api:             `project_code_add`,
            table_headers:        Resources.table_headers,
            breadcrumb:           Resources.breadcrumb,
            radio_options:        FormResources.radio_options,
            form_data:            FormResources.form_data,
            form_format:          FormResources.form_format,
            form_format_project:  FormResources.form_format_project,
            room_form_format:     FormResources.room_form_format,
            add_btn:              '',
            single_select:        false,
            table_selection:      [],
            search:               '',
            global_index:         '',
            single_object:        {},
            tasks:                [],
            array_options:        {},
            validate_data:        [],
            validation_table_headers: Resources.validation_table_headers
        }
    },

    watch:{

        'form_data.frequency_manual'(val)
        {
            if(val < 0 || val > 65)
            {
                this.form_data.frequency_manual = 1
            }
        },

        'form_data.type'(val)
        {
            this.form_data.task_id = ''

            if(val)
            {
                if(val == 'daily')
                {
                    this.array_options.task_id = this.tasks.filter(item => !item.project && !item.policing)
                }
                else if(val == 'policing')
                {
                    this.array_options.task_id = this.tasks.filter(item => !item.project && item.policing)
                }
                else if(val == 'project')
                {
                    this.array_options.task_id = this.tasks.filter(item => item.project && !item.policing)
                }
                
                this.array_options.task_id.length ? notyf.success('Tasks available') : notyf.error('No tasks found')
                this.form_format[0].disabled = false
                this.form_format[1].disabled = false
                this.form_format_project[0].disabled = false
                this.form_format_project[1].disabled = false
            }
        },

    },

    computed: {

        display_data()
        {
            return this.rooms.filter( item => this.form_data.building_id !== '' ? item.building_id === this.form_data.building_id : item )
            .filter( item => this.form_data.level_id !== '' ? item.level_id === this.form_data.level_id : item )
            .filter( item => this.form_data.area_id !== '' ? item.area_id === this.form_data.area_id : item )
            .filter( item => this.form_data.description !== '' ? item.description !== null ? item.description.toLowerCase().includes(this.form_data.description.toLowerCase()) : null : item )
        },

    },

    methods: 
    {
        async add_codes()
        {

            if(this.form_data.task_id === '')
            {
                notyf.error('No task selected')
                return false
            }

            let rooms_selected = this.$refs.advanced_search.returnedRoomsToParent()


            if(!rooms_selected.checked_items.length && !rooms_selected.select_all)
            {
                notyf.error('No rooms selected')
                return false
            }

            rooms_selected.checked_items    = rooms_selected.checked_items.map(item => item.origin_id)
            rooms_selected.unchecked_items  = rooms_selected.unchecked_items.map(item => item.origin_id)

            this.loader(true)

            let response = await this.post(this.rest_api, {...rooms_selected, ...this.form_data})
                
            this.loader()

            if(response.status)
            {
                if(response.data.validations.length)
                {
                    window.$('#validations').modal('show')
                    this.validate_data = response.data.validations;
                }
                this.$refs.advanced_search.replacingRooms(response.data.rooms)
                notyf.success('Success')
            }
            else
            {
                this.error_handling(response)
            }
        },

        fill_data(data)
        {
            this.tasks = data.tasks
            this.array_options = {
                frequency_id: data.frequencies,
            }
        },
        async getInitialData(data)
        {
            this.fill_data(data)
        }

    },

}

</script>
